<template>
  <div :style="{width: width, height: height}" id="chart" ref="chart"></div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    data: {
      required: true,
      type: Array,
    },
    dateFormat: {
      type: String,
      default: 'yyyyMMdd',
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '500px',
    },
  },
  mounted() {
    this.generateGraphics();
  },
  data() {
    return {
      chart: {},
    };
  },
  computed: {
    ...mapGetters([
      'am4Charts',
      'am4core',
    ]),
  },
  methods: {
    loaded() {
      setTimeout(() => {
        this.$emit('update-step');
      }, 550);
    },
    generateGraphics() {
      this.chart = this.am4core.create(this.$refs.chart, this.am4Charts.XYChart);
      this.chart.numberFormatter.decimalSeparator = ',';
      this.chart.numberFormatter.thousandsSeparator = '.';
      this.chart.numberFormatter.numberFormat = '#,###.##';
      this.chart.events.on('ready', () => this.loaded());

      this.chart.data = this.data;

      this.chart.dateFormatter.inputDateFormat = this.dateFormat;
      // create date axis
      const dateAxis = this.chart.xAxes.push(new this.am4Charts.DateAxis());
      dateAxis.renderer.minGridDistance = 60;
      dateAxis.startLocation = 0.5;
      dateAxis.endLocation = 0.5;
      dateAxis.baseInterval = {
        timeUnit: 'day',
        count: 1,
      };
      // create value axis
      const valueAxis = this.chart.yAxes.push(new this.am4Charts.ValueAxis());
      valueAxis.tooltip.disabled = true;
      // start create series by values
      const series = this.chart.series.push(new this.am4Charts.LineSeries());
      series.strokeWidth = 2;
      series.fillOpacity = 0.6;
      series.name = 'Gestiones';
      series.dataFields.dateX = 'date';
      series.dataFields.valueY = 'totals';
      series.tooltip.getFillFromObject = false;
      series.tooltip.background.strokeWidth = 3;
      series.tooltip.getStrokeFromObject = true;
      series.tooltipText = '[#000]{name}: {valueY.value}[/]';
      series.tooltip.background.fill = this.am4core.color('#FFF');

      const series2 = this.chart.series.push(new this.am4Charts.LineSeries());
      series2.strokeWidth = 2;
      series2.fillOpacity = 0.6;
      series2.name = 'Contactos';
      series2.dataFields.dateX = 'date';
      series2.dataFields.valueY = 'reached';
      series2.sequencedInterpolation = true;
      series2.tooltip.getFillFromObject = false;
      series2.tooltip.getStrokeFromObject = true;
      series2.tooltip.background.strokeWidth = 3;
      series2.tooltipText = '[#000]{name}: {valueY.value}[/]';
      series2.tooltip.background.fill = this.am4core.color('#FFF');

      const series3 = this.chart.series.push(new this.am4Charts.LineSeries());
      series3.strokeWidth = 2;
      series3.fillOpacity = 0.6;
      series3.name = 'Contacto útil';
      series3.dataFields.dateX = 'date';
      series3.sequencedInterpolation = true;
      series3.dataFields.valueY = 'contacted';
      series3.tooltip.getFillFromObject = false;
      series3.tooltip.getStrokeFromObject = true;
      series3.tooltip.background.strokeWidth = 3;
      series3.defaultState.transitionDuration = 1000;
      series3.tooltip.background.fill = this.am4core.color('#FFF');
      series3.tooltipText = '[#000]{name}: {valueY.value}[/]';

      const series4 = this.chart.series.push(new this.am4Charts.LineSeries());
      series4.strokeWidth = 2;
      series4.fillOpacity = 0.6;
      series4.name = 'Compromisos';
      series4.dataFields.dateX = 'date';
      series4.dataFields.valueY = 'promise';
      series4.sequencedInterpolation = true;
      series4.tooltip.getFillFromObject = false;
      series4.tooltip.getStrokeFromObject = true;
      series4.tooltip.background.strokeWidth = 3;
      series4.defaultState.transitionDuration = 1000;
      series4.tooltip.background.fill = this.am4core.color('#FFF');
      series4.tooltipText = '[#000]{name}: {valueY.value}[/]';

      series.fill = this.am4core.color('#46ccd9');
      series2.fill = this.am4core.color('#47bfb8');
      series3.fill = this.am4core.color('#55c187');
      series4.fill = this.am4core.color('#65e3a1');

      series.stroke = this.am4core.color('#46ccd9');
      series2.stroke = this.am4core.color('#47bfb8');
      series3.stroke = this.am4core.color('#55c187');
      series4.stroke = this.am4core.color('#65e3a1');

      this.chart.cursor = new this.am4Charts.XYCursor();
      this.chart.cursor.xAxis = dateAxis;
      this.chart.scrollbarX = new this.am4core.Scrollbar();

      // Add a legend
      this.chart.legend = new this.am4Charts.Legend();
      this.chart.legend.position = 'top';
    },
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.chart.data = this.data;
      },
    },
  },
};
</script>
<style scoped>
#chart {
  width: 80%;
  height: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/panelV2/Channels/PieLine/StackedArea.vue